// extracted by mini-css-extract-plugin
export var anchor = "_35-0";
export var discard = "_35-4";
export var muiTooltipTooltip = "_35-6";
export var notificationBar = "_35-3";
export var saveButtonHoverSlotWrapper = "_35-5";
export var show = "_35-2";
export var spacer = "_35-1";